import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ComplexCompareShortcutCard.css';

function ComplexCompareShortcutCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="compare-shortcut-card"
      onClick={() => navigate('/complex-compare')}
    >
      <div className="compare-shortcut-card__title-row">
        <span className="compare-shortcut-card__icon" aria-hidden="true">
          <img src="/assets/compare.png" alt="" className="compare-shortcut-card__icon-img" />
        </span>
        <div className="compare-shortcut-card__title">비교하기</div>
      </div>
      <p className="compare-shortcut-card__desc">단지별로 데이터를 한눈에 비교해보세요.</p>
      <span className="compare-shortcut-card__cta">비교 하러가기</span>
    </button>
  );
}

export default ComplexCompareShortcutCard;
